import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';

function Component(props) {
  const {  } = useParams();
  const navigate = useNavigate();
  const [data,setdata] = useState(null)
  const [isLoading,setisLoading]=useState(false)


  const fetchData=async(force=false)=>{
    if(isLoading&&!force)return
    setisLoading(true)
    // let result = await fetchWordById(props.token.token,id);
    // if(result.result){
    //     setdata(result.result)
    // }else{
    //     alert('Fetch data error')
    // }
    setisLoading(false)
  }
  useEffect(()=>{
    fetchData();
  },[])


  return (
    <div className='h-full flex-1 bg-[#F2F2F2]'>
        <img className='w-[100%]' style={{objectFit:'contain'}} src='/comingsoon.png'/>
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  